import React from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { Calendar } from 'primereact/calendar';
import ChassisDropdown from '../../../../components/common/ChassisDropdown';

/**
 * Arızalı parça detayları bölümü
 */
const FaultyPartDetailsSection = ({ 
    formData, 
    errors, 
    submitted, 
    onInputChange, 
    th 
}) => {
    if (!formData.isFaultyPart) {
        return null;
    }

    return (
        <>
            <div className="col-12">
                <h6 className="mb-1 mt-1">{th('dealerPartsReturnProcess.returnRequest.faultyPartDetails')}</h6>
            </div>

            {/* Şasi No */}
            <div className="col-12 md:col-6">
                <div className="field">
                    <label htmlFor="chassisNo">{th('dealerPartsReturnProcess.returnRequest.chassisNo')} *</label>
                    <ChassisDropdown 
                        value={formData.chassisNo} 
                        onChange={(value) => onInputChange('chassisNo', value)} 
                        className={submitted && errors.chassisNo ? 'p-invalid w-full' : 'w-full'} 
                    />
                    {submitted && errors.chassisNo && <small className="p-error">{errors.chassisNo}</small>}
                </div>
            </div>

            {/* Montaj KM */}
            <div className="col-12 md:col-6">
                <div className="field">
                    <label htmlFor="assemblyKm">{th('dealerPartsReturnProcess.returnRequest.assemblyKm')} *</label>
                    <InputNumber
                        id="assemblyKm"
                        value={formData.assemblyKm}
                        onValueChange={(e) => onInputChange('assemblyKm', e.value)}
                        className={submitted && errors.assemblyKm ? 'p-invalid w-full' : 'w-full'}
                        placeholder={th('dealerPartsReturnProcess.returnRequest.placeholders.assemblyKm')}
                        min={0}
                    />
                    {submitted && errors.assemblyKm && <small className="p-error">{errors.assemblyKm}</small>}
                </div>
            </div>

            {/* Arıza KM */}
            <div className="col-12 md:col-6">
                <div className="field">
                    <label htmlFor="faultKm">{th('dealerPartsReturnProcess.returnRequest.faultKm')} *</label>
                    <InputNumber
                        id="faultKm"
                        value={formData.faultKm}
                        onValueChange={(e) => onInputChange('faultKm', e.value)}
                        className={submitted && errors.faultKm ? 'p-invalid w-full' : 'w-full'}
                        placeholder={th('dealerPartsReturnProcess.returnRequest.placeholders.faultKm')}
                        min={0}
                    />
                    {submitted && errors.faultKm && <small className="p-error">{errors.faultKm}</small>}
                </div>
            </div>

            {/* Montaj Tarihi */}
            <div className="col-12 md:col-6">
                <div className="field">
                    <label htmlFor="assemblyDate">{th('dealerPartsReturnProcess.returnRequest.assemblyDate')} *</label>
                    <Calendar
                        id="assemblyDate"
                        value={formData.assemblyDate}
                        onChange={(e) => onInputChange('assemblyDate', e.value)}
                        className={submitted && errors.assemblyDate ? 'p-invalid w-full' : 'w-full'}
                        dateFormat="dd/mm/yy"
                        showIcon
                    />
                    {submitted && errors.assemblyDate && <small className="p-error">{errors.assemblyDate}</small>}
                </div>
            </div>

            {/* Arıza Tarihi */}
            <div className="col-12 md:col-6">
                <div className="field">
                    <label htmlFor="faultDate">{th('dealerPartsReturnProcess.returnRequest.faultDate')} *</label>
                    <Calendar 
                        id="faultDate" 
                        value={formData.faultDate} 
                        onChange={(e) => onInputChange('faultDate', e.value)} 
                        className={submitted && errors.faultDate ? 'p-invalid w-full' : 'w-full'} 
                        dateFormat="dd/mm/yy" 
                        showIcon 
                    />
                    {submitted && errors.faultDate && <small className="p-error">{errors.faultDate}</small>}
                </div>
            </div>
        </>
    );
};

export default FaultyPartDetailsSection;

